import React from 'react';
import { render } from 'react-dom';
import * as Sentry from '@sentry/react';

import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import theme from '../../../theme';
// TODO: Patch the design system to export this in index.js
import ErrorBoundary from '../../components/ErrorBoundary';
// Imports
import initStore from '../redux';
import App from './manager';
import AuthManager from '../../components/AuthManager';

/**
 * Add Sentry for React
 * Replace this when CAT-RCKMS is fully React driven
 */

Sentry.init({
    dsn: process.env.SENTRY_DSN || undefined,
    environment: process.env.SENTRY_ENVIRONMENT || undefined,
    release: process.env.SENTRY_RELEASE || undefined
});

Sentry.setContext('rckms_module', {
    name: 'Deploy Queue Manager'
});

let store = initStore();

const MountedApp = ({ ...props }) => (
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <AuthManager {...props}>
                {({ userContext }) => (
                    <ErrorBoundary>
                        <App userContext={userContext} />
                    </ErrorBoundary>
                )}
            </AuthManager>
        </ThemeProvider>
    </Provider>
);

render(<MountedApp />, document.getElementById('deployQueueRoot'));
